import _ from 'lodash';
import React from 'react';
import { string, object, number } from 'yup';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormResource from '../FormResource.jsx';

const defaults = {
  deliveryTime: {
    minWeeks: 0,
    maxWeeks: 0,
  },
  from: {
    _id: '',
  },
  to: {
    _id: '',
  },
};

const schema = object({
  deliveryTime: object({
    minWeeks: number().required('Min weeks is Required'),
    maxWeeks: number().required('Max weeks is Required'),
  }).test('deliveryTime', 'Min weeks cannot greater than max weeks', (value) => value.minWeeks <= value.maxWeeks),
  from: object({
    _id: string().required('Supplier is Required'),
  }),
  to: object({
    _id: string().required('Showroom is Required'),
  }),
});

const FormDeliveryTime = ({ deliveryTime }) => {
  const [resSupplier, reqSupplier] = useHttpStatus();
  React.useEffect(() => {
    reqSupplier({ url: '/api/core/tfy/suppliers' });
  }, []);

  const [resShowroom, reqShowroom] = useHttpStatus();
  React.useEffect(() => {
    reqShowroom({ url: '/api/core/showrooms' });
  }, []);

  return (
    <PageHttp res={[resSupplier, resShowroom]}>
      {([supplier, showroom]) => (
        <FormResource
          {...{
            defaults,
            stored: deliveryTime,
            initialValuesOpts: { omitIds: false },
            schema,
            api: '/api/core/tfy/deliveryTimes',
          }}>
          <div className="pt-3">
            <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">BASIC</h6>
            <div className="row">
              <div className="col">
                <FormGroup name='from._id' label="Supplier" as="select">
                  <option value=""> - </option>
                  {_.map(_.sortBy(supplier.rows, 'name'), ({ _id, name }) => (
                    <option value={_id} key={_id}>{`${name}`}</option>
                  ))}
                </FormGroup>
              </div>
              <div className="col">
                <FormGroup name='to._id' label="Showroom" as="select">
                  <option value=""> - </option>
                  {_.map(showroom.rows, (v) => (
                    <option value={v._id} key={v._id}>{`${v.orgId} - ${v.showroom}`}</option>
                  ))}
                </FormGroup>
              </div>
            </div>
            <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">DELIVERY TIME</h6>
            <div className="row">
              <div className="col">
                <FormGroup name='deliveryTime.minWeeks' type="number" min={1} label="Min Weeks" />
              </div>
              <div className="col">
                <FormGroup name='deliveryTime.maxWeeks' type="number" min={1} label="Max Weeks" />
              </div>
            </div>
          </div>
        </FormResource>
      )}
    </PageHttp>
  );
};

export default FormDeliveryTime;
